export default __webpack_public_path__ + "static/media/6.39cde1b7.jpg";